<template>
  <div data-v-03b1ba29="" class="payment-method dekbox">
    <div class="demain">
      <div data-v-03b1ba29="" class="topup-title">
        <span data-v-03b1ba29="">{{ $t('_m._yhxx') }}</span>
      </div>

      <div data-v-03b1ba29="" class="tips-wrapper">
        <div data-v-982acdfa="" data-v-03b1ba29="" class="tips">
          <div data-v-982acdfa="" class="bakdd1">
            <div class="kbpbb">{{ $t('_m._yhmz') }}</div>
            :
            <div class="bank-value-wrap">
              <span class="bank-value">{{ bankList.bank_name }}</span>
              <button class="bank-copy-btn" @click="onCopy(bankList.bank_name)">
                <CopyOutlined />
              </button>
            </div>
          </div>
          <div data-v-982acdfa="" class="bakdd1" v-if="bankList.bank_address">
            <div class="kbpbb">{{ $t('_m._yhdz') }}</div>
            :
            <div class="bank-value-wrap">
              <span class="bank-value">{{ bankList.bank_address }}</span>
              <button class="bank-copy-btn" @click="onCopy(bankList.bank_address)">
                <CopyOutlined />
              </button>
            </div>
          </div>
          <div data-v-982acdfa="" class="bakdd1" v-if="bankList.name">
            <div class="kbpbb">{{ $t('_m._yhmc') }}</div>
            :
            <div class="bank-value-wrap">
              <span class="bank-value">{{ bankList.name }}</span>
              <button class="bank-copy-btn" @click="onCopy(bankList.name)">
                <CopyOutlined />
              </button>
            </div>
          </div>
          <div data-v-982acdfa="" class="bakdd1" v-if="bankList.account">
            <div class="kbpbb">{{ $t('_m._yhzh') }}</div>
            :
            <div class="bank-value-wrap">
              <span class="bank-value">{{ bankList.account }}</span>
              <button class="bank-copy-btn" @click="onCopy(bankList.account)">
                <CopyOutlined />
              </button>
            </div>
          </div>
          <!-- <div data-v-982acdfa="" class="bakdd1">
            <div class="kbpbb">{{ $t('_m._yhlx') }}</div>
            :
            <div class="bank-value-wrap">
              <span class="bank-value">{{ bankList.bank_type }}</span>
              <button class="bank-copy-btn" @click="onCopy(bankList.bank_type)">
                <CopyOutlined />
              </button>
            </div>
          </div> -->
          <div data-v-982acdfa="" class="bakdd1" v-if="bankList.routing">
            <div class="kbpbb">{{ $t('_m._yhly') }}</div>
            :
            <div class="bank-value-wrap">
              <span class="bank-value">{{ bankList.routing }}</span>
              <button class="bank-copy-btn" @click="onCopy(bankList.routing)">
                <CopyOutlined />
              </button>
            </div>
          </div>
          <div data-v-982acdfa="" class="bakdd1" v-if="bankList.code">
            <div class="kbpbb">{{ $t('_m._yhdm') }}</div>
            :
            <div class="bank-value-wrap">
              <span class="bank-value">{{ bankList.code }}</span>
              <button class="bank-copy-btn" @click="onCopy(bankList.code)">
                <CopyOutlined />
              </button>
            </div>
          </div>
          <div data-v-982acdfa="" class="bakdd1">
            <div class="kbpbb">{{ $t('_m._yhbz') }}</div>
            :
            <div class="bank-value-wrap">
              <span class="bank-value">{{ userInfo?.uid || '' }}</span>
              <button class="bank-copy-btn" @click="onCopy(userInfo?.uid || '')">
                <CopyOutlined />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div data-v-03b1ba29="" class="tips-wrapper">
        <div data-v-982acdfa="" data-v-03b1ba29="" class="tips">
          <p data-v-982acdfa="">{{ $t('_m._zts') }}:</p>
          <p data-v-982acdfa="">{{ $t('_m._zyd1') }}</p>
          <p data-v-982acdfa="">{{ $t('_m._zyd2') }}</p>
          <p data-v-982acdfa="">{{ $t('_m._zyd3') }}</p>
          <p data-v-982acdfa="">{{ $t('_m._zyd4') }}</p>
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-footer">
        <button data-v-03b1ba29="" class="payment-btn" @click="onCopyInfo()">
          <span data-v-03b1ba29="">{{ $t('_m._fzxx') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { CopyOutlined } from '@ant-design/icons-vue'
export default {
  name: 'depositVue',
  components: { CopyOutlined },
  data() {
    return {
      bankList: [],
      userInfo: {}
    }
  },
  created() {
    this.userInfo = this.$common.getInfo()
    this.getBankList()
  },
  methods: {
    getBankList() {
      let that = this
      this.$api.bank.getBankList().then((res) => {
        that.bankList = res.data
      })
    },
    onCopy(token) {
      if (!token) return
      console.log(token)
      // 使用原生 clipboard API 复制
      navigator.clipboard
        .writeText(String(token))
        .then(() => {
          this.$message.success('copy success! ' + String(token))
        })
        .catch(() => {
          this.$message.error('copy fail')
        })
    },
    onCopyInfo() {
      let info = ''

      if (this.bankList.bank_name) {
        info = info + this.bankList.bank_name
      }
      if (this.bankList.bank_address) {
        if (info) {
          info = info + '\r\n'
        }
        info = info + this.bankList.bank_address
      }
      if (this.bankList.name) {
        if (info) {
          info = info + '\r\n'
        }
        info = info + this.bankList.name
      }
      if (this.bankList.account) {
        if (info) {
          info = info + '\r\n'
        }
        info = info + this.bankList.account
      }
      if (this.bankList.routing) {
        if (info) {
          info = info + '\r\n'
        }
        info = info + this.bankList.routing
      }
      if (this.bankList.code) {
        if (info) {
          info = info + '\r\n'
        }
        info = info + this.bankList.code
      }

      if (this.userInfo.uid) {
        if (info) {
          info = info + '\r\n'
        }
        info = info + this.userInfo.uid
      }

      // 使用原生 clipboard API 复制
      navigator.clipboard
        .writeText(String(info))
        .then(() => {
          this.$message.success('copy success! ' + String(info))
        })
        .catch(() => {
          this.$message.error('copy fail')
        })
    }
  }
}
</script>
<style scoped>
@import url('../../static/css_deposit/index.B4UqQ7MX.css');
</style>
<style>
.dekbox {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.demain {
  width: 1200px;
}

.record-a {
  padding-top: 36px;
}

.asdrt {
  color: #fff;
  font-family: Ubuntu-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
}

.bakdd1 {
  display: flex;
  gap: 10px;
  align-items: center;
}

.bank-value-wrap {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.bank-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bank-copy-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #929aa8;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.bank-copy-btn:hover {
  color: #fb3867;
  background: rgba(251, 56, 103, 0.08);
}

.bank-copy-btn:active {
  transform: scale(0.9);
}
</style>
